import styled from 'styled-components';
import { M } from '@dashboard-experience/mastodon';

// Carbon caps an inline notification at 18rem to 46rem depending on the
// breakpoint; the Bootstrap alert it replaces filled its container.
const FullWidthInlineNotification = styled(M.InlineNotification)`
  &.cds--inline-notification {
    max-width: 100%;
    margin: 0 0 16px;
  }
`;

export default FullWidthInlineNotification;
